import { Outlet, Navigate, useLocation } from "react-router-dom";
import { SidebarProvider } from "@/components/ui/sidebar";
import { PlatformSidebar } from "./PlatformSidebar";
import { PlatformHeader } from "./PlatformHeader";
import { useAuth } from "@/auth/AuthContext";
import { AuthSplash } from "./AuthSplash";

export function PlatformLayout() {
  const { user, employee, loading } = useAuth();
  const location = useLocation();
  if (loading) return <AuthSplash />;
  // Same reasoning as AppLayout: an employee-only principal sent to /login
  // would loop, because Clerk still reports them signed in (FEAT-2026-013).
  if (!user && employee) return <Navigate to="/me" replace />;
  if (!user) return <Navigate to="/login" replace state={{ from: location }} />;
  if (user.roleType !== "super_admin") return <Navigate to="/" replace />;

  return (
    <SidebarProvider defaultOpen>
      <div className="flex min-h-screen w-full bg-background">
        <PlatformSidebar />
        <div className="flex min-w-0 flex-1 flex-col">
          <PlatformHeader />
          <main className="flex-1 p-4 md:p-6 lg:p-8 animate-fade-in">
            <Outlet />
          </main>
        </div>
      </div>
    </SidebarProvider>
  );
}
